import type { RefObject } from "react";
import { NavIconBell, NavIconCog, NavIconMenu, SignOutIcon } from "./NavIcons";

export function TopNavBar({
  initials,
  isUserMenuOpen,
  notificationCount,
  onLocationChange,
  onLogout,
  onSidebarToggle,
  onUserMenuToggle,
  refAvatar,
  refMenu,
  showBrandIcon,
  showCompactTitle,
  showSidebarToggle,
  sidebarWidth,
  username,
}: Readonly<{
  initials: string;
  isUserMenuOpen: boolean;
  notificationCount: number;
  onLocationChange: (to: string) => void;
  onLogout: () => void;
  onSidebarToggle: () => void;
  onUserMenuToggle: () => void;
  refAvatar: RefObject<HTMLButtonElement>;
  refMenu: RefObject<HTMLDivElement>;
  showBrandIcon: boolean;
  showCompactTitle: boolean;
  showSidebarToggle: boolean;
  sidebarWidth: number;
  username: string;
}>) {
  return (
    <header
      className="fixed right-0 top-0 z-30 flex h-14 items-center justify-between gap-3 bg-litmus-dark-green-900 px-4 text-white"
      style={{
        left: sidebarWidth,
        transition: showSidebarToggle ? "none" : "left 250ms ease-in-out",
      }}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        {showSidebarToggle && (
          <button
            className="top-nav-icon-button"
            type="button"
            onClick={onSidebarToggle}
            aria-label="Open sidebar"
          >
            <NavIconMenu />
          </button>
        )}
        {showBrandIcon && (
          <img
            className="h-7 w-7 shrink-0 object-contain"
            src="/assets/Litmus_Logo.png"
            alt="Litmus"
          />
        )}
        <div className="shrink-0 truncate text-[22px] font-medium leading-snug text-litmus-light-green-500">
          {" "}
          {showCompactTitle ? "Catalog Agent" : "Litmus Catalog Agent"}
        </div>
      </div>

      <div className="relative flex shrink-0 items-center gap-2">
        {/* Notification bell */}
        <button
          type="button"
          className="relative top-nav-icon-button"
          onClick={() => onLocationChange("/notifications")}
          aria-label={
            notificationCount > 0
              ? `${notificationCount} notifications`
              : "Notifications"
          }
        >
          <span className="flex h-[18px] w-[18px] items-center justify-center">
            <NavIconBell />
          </span>
          {notificationCount > 0 && (
            <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-rose-500 font-mono text-[9px] font-bold leading-none text-white">
              {notificationCount > 9 ? "9+" : notificationCount}
            </span>
          )}
        </button>

        {/* Avatar / user menu */}
        <button
          ref={refAvatar}
          className="top-nav-avatar"
          type="button"
          onClick={onUserMenuToggle}
          aria-label="Open user menu"
        >
          <span>{initials}</span>
        </button>

        {isUserMenuOpen && (
          <div ref={refMenu} className="user-dropdown">
            <div className="border-b border-datahub-gray-100 px-4 py-3">
              <div className="truncate text-[14px] font-bold text-datahub-gray-600">
                {username}
              </div>
            </div>
            <button
              type="button"
              className="user-dropdown-item"
              onClick={() => onLocationChange("/settings")}
            >
              <NavIconCog />
              <span>Settings</span>
            </button>
            <button
              type="button"
              className="user-dropdown-item"
              onClick={onLogout}
            >
              <SignOutIcon />
              <span>Sign out</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
